import { ManageTable, type ManageField } from '@/components/ManageTable'
import { Input } from '@/components/ui/input'
import { usePersistentState } from '@/hooks/usePersistentState'

export default function IpPool() {
  const [filters, setFilter, clearFilters] = usePersistentState<Record<string, any>>(
    'admin:ip-pool:filters',
    {},
  )

  const handleResetFilters = () => {
    clearFilters()
  }

  const fields: ManageField[] = [
    {
      desc: 'account',
      field: 'account',
    },
    {
      desc: 'address',
      field: 'address',
    },
    {
      desc: 'content',
      field: 'content',
    },
    {
      desc: 'duration',
      field: 'duration',
    },
    {
      desc: 'bindHost',
      field: 'bindHost',
    },
    {
      desc: 'transform_url',
      field: 'transform_url',
    },
    {
      desc: 'is_rd',
      field: 'is_rd',
      render: (val) => (val ? 'rd' : ''),
    },
    {
      desc: 'update_time',
      field: 'update_time',
    },
    {
      desc: 'create_time',
      field: 'create_time',
    },
  ]

  const filterUI = (
    <div className="flex gap-2">
      <Input
        placeholder="account"
        className="w-[150px]"
        value={filters.account || ''}
        onChange={(e) => {
          const newFilters = { ...filters }
          if (e.target.value) {
            newFilters.account = e.target.value
          } else {
            delete newFilters.account
          }
          setFilter(newFilters)
        }}
      />
      <Input
        placeholder="address"
        className="w-[150px]"
        value={filters.address || ''}
        onChange={(e) => {
          const newFilters = { ...filters }
          if (e.target.value) {
            newFilters.address = e.target.value
          } else {
            delete newFilters.address
          }
          setFilter(newFilters)
        }}
      />
    </div>
  )

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">IP池管理</h1>
      <ManageTable fields={fields} collect="ip_pool" filters={filters} filter={filterUI} onResetFilters={handleResetFilters} />
    </div>
  )
}
